import { Component, Input } from '@angular/core';

@Component({
    selector   : 'my-inputButton',
    template: require('./inputButton.component.html'),
    styles: [require('./inputButton.component.scss')]
})

export class InputButtonComponent {

    @Input() input: any;
    @Input('placeholder') placeholder: string;
    @Input('model') model: any;
    @Input('field') field: string;
    @Input('activate') activate: boolean;
    @Input('disabled') disabled: boolean;
    @Input('toggle') toggle:boolean = false;
    @Input('style') style:string = '';
    @Input('value') value:string = null;

    constructor() {

    }

    save() {
        if (this.value) {
            this.model[this.field] = this.value;
            return;
        }
        if (this.toggle && this.activate)
            return ;
        this.model[this.field] = !this.model[this.field];
        this.model.modelChange(this.field);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/components/inputButton/inputButton.component.ts